class DataTypes {
  // eslint-disable-next-line no-useless-constructor
  constructor () {}

  // Returns if a value is an object
  isObject (value) {
    return value && typeof value === 'object' && value.constructor === Object
  }

  // Returns if a value is null
  isNull (value) {
    return value === null
  }

  // Returns if a value is undefined
  isUndefined (value) {
    return typeof value === 'undefined'
  }

  isNullOrUndefined (value) {
    if (this.isNull(value) || this.isUndefined(value)) { return true }
    return false
  }

  // Returns if a value is a boolean
  isBoolean (value) {
    return typeof value === 'boolean'
  }

  // Returns if a value is a regexp
  isRegExp (value) {
    return value && typeof value === 'object' && value.constructor === RegExp
  }

  // Returns if value is an error object
  isError (value) {
    return value instanceof Error && typeof value.message !== 'undefined'
  }

  // Returns if value is a date object
  isDate (value) {
    return value instanceof Date
  }

  // Returns if a Symbol
  isSymbol (value) {
    return typeof value === 'symbol'
  }

  // Returns if a value is really a number
  isNumber (value) {
    return typeof value === 'number' && isFinite(value)
  }

  // Returns if a value is an array
  isArray (value) {
    return Array.isArray(value)
    // return value && typeof value === 'object' && value.constructor === Array;
  }

  // Returns if a value is a function
  isFunction (value) {
    return typeof value === 'function'
  }

  // Returns if a value is a string
  isString (value) {
    return typeof value === 'string' || value instanceof String
  }

  isNullOrEmpty (value) {
    if (value === null || value === undefined) return true
    if (!this.isString(value)) return true
    const empty = /^\s*$/.test(value)
    // console.log('isNullOrEmpty:', value, empty)
    return empty
  }
}

export default DataTypes
